// extracted by mini-css-extract-plugin
export var root_reset = "plasmic_kube_data_website-module--root_reset--1jv3B";